import { useEffect, useRef } from 'react';
import { parseFedRoute, goFedRoute } from './deeplink';

export function useFedHistory(route, { tourId, tourTab, teamJoinCode, articleId, projectId, messengerId, adminSection, adminEditId, adminTourTab }) {
  const historyReady = useRef(false);
  useEffect(() => {
    const restore = () => {
      const raw = window.location.hash.slice(1)
        || window.location.pathname.replace(/^\/+|\/+$/g, '');
      goFedRoute(parseFedRoute(raw) || { target: raw ? 'notfound' : 'home' });
    };
    window.addEventListener('popstate', restore);
    return () => {
      window.removeEventListener('popstate', restore);
      historyReady.current = false;
    };
  }, []);

  useEffect(() => {
    if (!historyReady.current) {
      historyReady.current = true;
      window.history.replaceState({ ...window.history.state, fedDepth: 0 }, '');
      return;
    }
    let seg = route;
    if (route === 'tournament' && tourId) seg = `tournament/${encodeURIComponent(tourId)}`;
    else if (route === 'article' && articleId) seg = `article/${encodeURIComponent(articleId)}`;
    else if (route === 'project' && projectId) seg = `project/${encodeURIComponent(projectId)}`;
    else if (route === 'messenger' && messengerId) seg = `messenger/${encodeURIComponent(messengerId)}`;
    const params = new URLSearchParams();
    if (route === 'tournament' && tourTab && tourTab !== 'overview') params.set('tab', tourTab);
    if (route === 'tournament' && tourTab === 'reg' && teamJoinCode) params.set('join', teamJoinCode);
    if (route === 'admin') {
      if (adminSection && adminSection !== 'dash') params.set('section', adminSection);
      if (adminEditId) params.set('edit', adminEditId);
      if (adminSection === 'tourEdit' && adminTourTab && adminTourTab !== 'info') params.set('tab', adminTourTab);
    }
    if (params.toString()) seg += `?${params}`;
    const url = route === 'home' ? '/' : '/#' + seg;
    if (window.location.pathname + window.location.hash === url) return;
    window.history.pushState({ fedDepth: (window.history.state?.fedDepth || 0) + 1 }, '', url);
  }, [route, tourId, tourTab, teamJoinCode, articleId, projectId, messengerId, adminSection, adminEditId, adminTourTab]);
}
